import axios, { AxiosInstance } from 'axios';
import { gqlUri } from 'core/config/gql/client';
import { DocumentNode } from 'graphql';
import * as yup from 'yup';

export const axiosResponseSchema = yup.object().shape({
    data: yup.mixed().required(),
    status: yup.number().required(),
    statusText: yup.string(),
    headers: yup.object().required(),
    config: yup.object().required(),
    request: yup.mixed().required(),
});

export type GraphQLAxiosResponse = yup.InferType<typeof axiosResponseSchema>;

class GraphQLAxiosClient {
    private client: AxiosInstance;

    constructor(token: string) {
        this.client = axios.create({
            baseURL: gqlUri,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'x-auth-token': token,
            },
        });
    }

    async request(query: DocumentNode, variables: unknown): Promise<GraphQLAxiosResponse> {
        const requestBody = query.loc?.source?.body;
        // @ts-ignore
        const operationName = query.definitions[0]?.name?.value;
        const payload = {
            operationName: operationName,
            query: requestBody,
            variables: variables || {},
        };
        const response = await this.client.post('', payload);

        return await axiosResponseSchema.validate(response);
    }
}

export const generateGraphQLClient = (token: string) => new GraphQLAxiosClient(token);
